<template>
  <ims-page :requireLogin="true">
    <!-- Page Header -->
    <template v-slot:header>
      <ims-toolbar color="white">
        <template v-slot:left>
          <ims-menu-button />
        </template>
        <span class="title md">
          <img :src="$store.state.brand.gameLogo" height="46" />
        </span>
      </ims-toolbar>
      <!-- Tab Bar -->
      <ims-toolbar size="md" class="px-1" color="white">
        <nav class="ims-tabs">
          <ims-button
            :class="`tab ${view == 'my-team' ? 'active' : ''}`"
            @click="showTeams()"
          >My Team</ims-button>
          <ims-button
            :class="`tab ${view == 'leagues' ? 'active' : ''}`"
            @click="showLeagues()"
          >Leagues</ims-button>
        </nav>
      </ims-toolbar>
    </template>
    <!-- End Page Header -->

    <main class="container p-0" v-if="$store.state.user.loggedIn">
      <my-team
        :class="`my-team-panel ${view == 'my-team' ? 'visible' : 'hidden'}`"
        @change="teamChanged"
      />
      <leagues v-if="view == 'leagues'" @change="hasChanges = true" />
    </main>
    <template v-slot:footer>
      <!-- Save Team Button -->
      <ims-toolbar v-if="hasChanges && $props.tab == 'my-team'" color="primary">
        <div class="filler" />
        <ims-button
          v-if="picksSelectedCount == race.pickCount"
          type="solid"
          color="white"
          @click="saveChanges()"
          class="animate notice save-button px-4 filler"
        >Save Changes</ims-button>
        <ims-button
          v-else
          type="solid"
          color="white"
          style="opacity:0.6"
          class="animate notice save-button px-4 filler"
        >
          Pick {{ race.pickCount - picksSelectedCount }} Drivers to
          Save
        </ims-button>
        <div class="filler" />
      </ims-toolbar>
    </template>
  </ims-page>
</template>

<script>
import MyTeam from '../containers/my-team/my-team.vue';
import Leagues from '../containers/leagues/leagues.vue';

// Make logo dynamic for white labeling
import tick from '../modules/tick/tick';

export default {
  components: {
    MyTeam,
    Leagues
  },
  props: ['tab'],
  data() {
    return {
      hasChanges: false,
      view: 'my-team',
      teamChanges: null
    };
  },
  computed: {
    race() {
      return this.$store.state.races.race;
    },
    picksSelectedCount() {
      let picks = [
        this.teamChanges.pick1,
        this.teamChanges.pick2,
        this.teamChanges.pick3,
        this.teamChanges.pick4,
        this.teamChanges.pick5,
        this.teamChanges.pick6,
        this.teamChanges.pick7,
        this.teamChanges.pick8
      ];
      let count = 0;
      picks.forEach(pick => {
        if (pick && pick > 0) {
          count++;
        }
      });
      return count;
    }
  },
  watch: {
    '$store.state.races.race'() {
      this.hasChanges = false;
    }
  },
  /**
   * Many of these methods should
   * be moved to a Store in the future
   * We're just running out of time to optimize the front end
   * sorry future devs...
   */
  methods: {
    teamChanged(team) {
      // Force Tie Breaker into a Float
      if (typeof team.tieBreaker == 'string') {
        team.tieBreaker = parseFloat(team.tieBreaker);
        team.tieBreaker = !isNaN(team.tieBreaker) ? team.tieBreaker : 0;
      }
      this.teamChanges = team;
      this.hasChanges = true;
    },
    async saveChanges() {
      let closeLoader = await this.$store.dispatch(
        'loader/start',
        'Saving Team...'
      );

      //TODO - Should this be here? - the SSO should handle it
      this.teamChanges.userId = this.$User.profile.id;

      // Save a Team to the service
      let saveTeam;
      try {
        saveTeam = await this.$User.service.saveTeam(
          this.$store.state.races.race.id,
          this.teamChanges
        );
        if (!this.teamChanges.id) {
          this.teamChanges.id = saveTeam.id;
        }
      } catch (e) {
        this.$store.dispatch('interact/popmenu', {
          title: 'Error Saving Team',
          description: e.message,
          cancelButton: 'Ok'
        });
      }
      // Did it save?
      if (saveTeam) {
        this.teamChanges = saveTeam;
        this.$store.dispatch('interact/toast', { title: 'Team Saved' });
        this.hasChanges = false;
      }

      closeLoader();
    },
    showTeams() {
      this.view = 'my-team';
      if (this.$router.currentRoute.name !== 'home') {
        this.$router.push('home');
      }
      this.$store.dispatch('document/title', 'My Team');
    },
    showLeagues() {
      this.view = 'leagues';
      if (this.$router.currentRoute.name !== 'leagues') {
        this.$router.push('leagues');
      }
      this.$store.dispatch('document/title', 'My Leagues');
    }
  },
  created() {
    if (this.$props.tab) {
      this.view = this.$props.tab;
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.save-button {
  box-shadow: 0px 3px 10px -2px rgba(0, 0, 0, 0.2);
}
.my-team-panel.hidden {
  display: none;
}
</style>
